interface Props {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

// Optional trim name (issue #52) — same text-input treatment as the Fabric
// Description field. Falls back to the generic "Trim" label server-side when
// left blank.
export default function TrimNameInput({ value, onChange, disabled }: Props) {
  return (
    <div className="form-group" style={{ flex: 1 }}>
      <label>Trim Name <span style={{ color: '#9ca3af', fontWeight: 400 }}>(optional)</span></label>
      <input
        type="text"
        className="input"
        placeholder="e.g., Grosgrain Ribbon"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      />
    </div>
  );
}
